// extracted by mini-css-extract-plugin
export default {"corFundo":"home_corFundo__bDst8","dashboards":"home_dashboards__8TYlR"};